import { CapitalImprovementProjects } from './sections/CapitalImprovementProjects';
import { ConflictSummary } from './sections/ConflictSummary';
import { DataRefreshStatus } from './sections/DataRefreshStatus';
import { PavingMoratoria } from './sections/PavingMoratoria';
import { PavingProjects } from './sections/PavingProjects';

export function Conflicts() {
  const handleConflictClick = (conflictType: string) => {
    // scroll into view and highlight the conflict type
    const element = document.getElementById(conflictType);
    if (element) {
      element.style.scrollMarginTop = '20px';
      element.scrollIntoView({ behavior: 'smooth' });
      const highlightClasses = ['transition-colors', 'duration-300', 'outline-2', 'outline-offset-2'];
      element.classList.add(...highlightClasses, 'outline-blue-300');
      setTimeout(() => {
        element.classList.replace('outline-blue-300', 'outline-transparent');
        setTimeout(() => element.classList.remove(...highlightClasses, 'outline-transparent'), 300);
      }, 1000);
    }
  };

  return (
    <div className="py-3 space-y-3">
      <ConflictSummary onConflictClick={handleConflictClick} />
      <PavingProjects />
      <PavingMoratoria />
      <CapitalImprovementProjects />
      <DataRefreshStatus />
    </div>
  );
}
